import cx from 'classnames';
import parse from 'html-react-parser';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { FunctionComponent } from 'react';

import BPImage from '../../ui/v2/image';

export type TContactAttribute = {
  label: string;
  value: string | undefined;
  variant: 'email' | 'phone' | string;
};
export type TContact = {
  flag: {
    src: string;
    alt: string;
  };
  title: string;
  attributes: Array<TContactAttribute>;
};

const CountriesContacts: FunctionComponent<{
  contacts: Array<TContact>;
  classname?: string;
}> = ({ contacts, classname }) => {
  const { t } = useTranslation();
  return (
    <ul
      className={cx({
        'lg:grid lg:grid-cols-4 lg:gap-24 mt-4 lg:mt-0': !classname,
        [classname as string]: !!classname,
      })}
    >
      {contacts.map((item) => (
        <li key={item.title} className="py-3">
          <div className="rounded-xl shadow-md h-6 inline-block">
            <BPImage
              height={24}
              width={24}
              layout="fixed"
              src={item.flag.src}
              alt={t(item.flag.alt)}
              className="shadow"
            />
          </div>
          <h3 className="ml-4 font-bold text-lg inline absolute">
            {t(item.title)}
          </h3>

          <dl className="text-xs">
            {item.attributes.map(
              (attr) =>
                attr.value && (
                  <div key={attr.label} className="mt-4">
                    <dt className='font-bold text-sm'>{t(attr.label)}</dt>
                    <dd>
                      {attr.variant == 'email' ? (
                        <address className="not-italic !tracking-normal text-base">
                          <Link
                            href={`mailto:${attr.value}`}
                            passHref
                            className="text-neutral-80"
                          >
                            {attr.value}
                          </Link>
                        </address>
                      ) : attr.variant == 'phone' ? (
                        <address className="not-italic !tracking-normal text-base">
                          <Link
                            href={`tel:${attr.value}`}
                            passHref
                            className="text-neutral-80"
                          >
                            {attr.value}
                          </Link>
                        </address>
                      ) : (
                        <address className="not-italic !tracking-normal text-base">
                          {parse(attr.value)}
                        </address>
                      )}
                    </dd>
                  </div>
                )
            )}
          </dl>
        </li>
      ))}
    </ul>
  );
};

export default CountriesContacts;
